import { EdgeLabelRenderer, useViewport } from "reactflow";
import { type Cursor } from "../hooks/useCursorStateSynced";

function Cursors({ cursors }: { cursors: Cursor[] }) {
  const viewport = useViewport();

  return (
    <EdgeLabelRenderer>
      {cursors.map(({ id, color, x, y }) => {
        const translate = `translate(${x}px, ${y}px)`;
        const scale = `scale(${1 / viewport.zoom})`;

        return (
          <svg key={id} className="cursor" style={{ transform: translate }}>
            <g style={{ transform: scale }}>
              <path
                d={cursorPath}
                fill={color}
                fillRule="evenodd"
                clipRule="evenodd"
              />
            </g>
          </svg>
        );
      })}
    </EdgeLabelRenderer>
  );
}

const cursorPath = `
  M3.29227 0.048984C3.47033 -0.032338 3.67946 -0.00228214 3.8274 0.125891L12.8587
  7.95026C13.0134 8.08432 13.0708 8.29916 13.0035 8.49251C12.9362 8.68586 12.7578
  8.81866 12.5533 8.82768L9.21887 8.97474L11.1504 13.2187C11.2648 13.47 11.1538
  13.7664 10.9026 13.8808L8.75024 14.8613C8.499 14.9758 8.20255 14.8649 8.08802
  14.6137L6.15339 10.3703L3.86279 12.7855C3.72196 12.934 3.50487 12.9817 3.31479
  12.9059C3.1247 12.8301 3 12.6461 3 12.4414V0.503792C3 0.308048 3.11422 0.130306 
  3.29227 0.048984ZM4 1.59852V11.1877L5.93799 9.14425C6.05238 9.02363 6.21924 8.96776
  6.38319 8.99516C6.54715 9.02256 6.68677 9.12965 6.75573 9.2809L8.79056 13.7441L10.0332
  13.178L8.00195 8.71497C7.93313 8.56376 7.94391 8.38824 8.03072 8.24659C8.11753
  8.10494 8.26903 8.01566 8.435 8.00834L11.2549 7.88397L4 1.59852z
`;

export default Cursors;
